import ParticipantPage from "./participant.container";

export default ParticipantPage;
